import { select } from 'redux-saga/effects';
import { ReduxState } from '../reducers';

export function selectState<T>(selector: (state: ReduxState) => T) {
  return select(selector);
}
